import api from './api';
import ErrorHandler from './errorHandler';

class AiTemplateCategoryService {
    async list() {
        try {
            const response = await api.get('/api/ai-template-categories');
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async get(id) {
        try {
            const response = await api.get(`/api/ai-template-categories/${id}`);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async create(data) {
        try {
            const response = await api.post('/api/ai-template-categories', data);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async update(id, data) {
        try {
            const response = await api.put(`/api/ai-template-categories/${id}`, data);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    // Pin/unpin a category in the user gallery — only one can be pinned;
    // the backend unpins the rest when pinning a new one.
    async pin(id, pinned) {
        try {
            const response = await api.patch(`/api/ai-template-categories/${id}/pin`, { pinned });
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async remove(id) {
        try {
            const response = await api.delete(`/api/ai-template-categories/${id}`);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }
}

export default new AiTemplateCategoryService();
